import { Colors } from "@/constants/Colors";
import { FontFamilies } from "@/constants/Typography";
import React, { useMemo } from "react";
import {
  StyleProp,
  StyleSheet,
  Text,
  TextStyle,
  TouchableOpacity,
  type TouchableOpacityProps,
} from "react-native";

export type ActionButtonProps = TouchableOpacityProps & {
  title: string;
  type?: "primary" | "secondary" | "hide";
  disabled?: boolean;
  lightColor?: string;
  darkColor?: string;
  icon?: React.ReactNode;
  iconPosition?: "left" | "right";
  textStyle?: StyleProp<TextStyle>;
};

export function ActionButton({
  title,
  type = "primary",
  disabled = false,
  style,
  lightColor,
  darkColor,
  icon,
  iconPosition = "left",
  textStyle,
  ...rest
}: ActionButtonProps) {
  const backgroundColor =
    type === "primary" ? Colors.primaryButton : Colors.bgSecondary;
  const textColor = useMemo(() => {
    if (type === "primary") return "#FFFFFF";
    if (type === "secondary") return Colors.primaryButton;
    if (type === "hide") return Colors.hideText;
    return Colors.text;
  }, [type]);
  const borderColor =
    type === "secondary" ? Colors.primaryButton : "transparent";

  return (
    <TouchableOpacity
      style={[
        styles.button,
        {
          backgroundColor,
          borderColor,
          borderWidth: type === "secondary" ? 1 : 0,
          opacity: disabled ? 0.3 : 1,
        },
        style,
      ]}
      disabled={disabled}
      {...rest}
    >
      {iconPosition === "left" ? icon : null}
      <Text style={[styles.text, { color: textColor }, textStyle]}>
        {title}
      </Text>
      {iconPosition === "right" ? icon : null}
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  button: {
    flexDirection: "row",
    gap: 8,
    height: 58,
    borderRadius: 100, // Half of height for full pill shape
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 32,
    minWidth: 120,
  },
  text: {
    fontFamily: FontFamilies.InterTight.SemiBold,
    fontSize: 17,
    textAlign: "center",
  },
});
